import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';

type WhatAreYourChancesFormatterProps = Readonly<{
  actionPlan: string;
}>;

export const WhatAreYourChancesFormatter = ({ actionPlan }: WhatAreYourChancesFormatterProps) => {
  if (!actionPlan) return null;

  // replace double spaces with a single space for proper markdown formatting
  const cleanedActionPlan = actionPlan.replace(/ {2}\n/g, '\n');

  return (
    <Box>
      <ReactMarkdown
        components={{
          p: ({ children }) => <p style={{ whiteSpace: 'pre-line' }}>{children}</p>,
        }}
      >
        {cleanedActionPlan}
      </ReactMarkdown>
    </Box>
  );
};
